import React, { useMemo, useState } from "react";
import { useGameIdFromRoute } from "./WithGameIdFromRoute";
import { NoPublisherInterest, PublisherListEntry2 } from "./PublisherInterestList";
import { PublisherInterestInGame } from "./PublisherInterestInGame";
import { useGamePublishers, useMyEntitlements } from "@seabrookstudios/pitch2table";
import { PublisherListFilters } from "./publisher-interest/filters";
import { idExtractor, useMakeListAndDetail, useMakeListBuilder } from "../core/useMakeLayout";
import { AddPublisherInterest } from "./publisher-interest/AddPublisherInterest";
import { Features } from "./features";
import { useNavigate } from "react-router-dom";
import { Path } from "../Path";
import IconButton from "@mui/material/IconButton";
import Add from "@mui/icons-material/Add";
import { PublisherListEntryWithFit } from "../publishers/ListItem";

/**
 * @param {Object} props
 * @param {import("@seabrookstudios/types").GameId} props.gameId
 */
const NavigateToResearch = ({ gameId }) => {
  const navigate = useNavigate();

  return (
    <IconButton color="primary" onClick={() => navigate(Path.game(gameId).research())}>
      <Add />
    </IconButton>
  );
};

export const PublisherInterestListAndDetail = () => {
  const gameId = useGameIdFromRoute();
  const [isAddPublisherOpen, setAddPublisherOpen] = useState(false);

  const { data: entitlements } = useMyEntitlements();

  const showPublisherResearch = Features.PublisherResearch && entitlements?.hasSKU0002;

  const Action = useMemo(() => {
    return function PublisherInterestListAction() {
      if (showPublisherResearch) {
        return <NavigateToResearch gameId={gameId} />;
      }

      return (
        <IconButton color="primary" onClick={() => setAddPublisherOpen(true)} id="add-publisher-interest">
          <Add />
        </IconButton>
      );
    };
  }, [gameId, showPublisherResearch]);

  const useMakeList = useMemo(
    () =>
      useMakeListBuilder(
        showPublisherResearch ? PublisherListEntryWithFit : PublisherListEntry2,
        idExtractor,
        "Publisher Interest",
        NoPublisherInterest,
        Action
      ),
    [showPublisherResearch, Action]
  );

  const useWrappedQuery = () => useGamePublishers(gameId);

  const ListAndDetail = useMakeListAndDetail(
    useWrappedQuery,
    PublisherListFilters,
    "publisher-interest",
    useMakeList,
    PublisherInterestInGame
  );

  return (
    <>
      <ListAndDetail />
      {!showPublisherResearch && (
        <AddPublisherInterest
          gameId={gameId}
          open={isAddPublisherOpen}
          onClose={() => {
            setAddPublisherOpen(false);
          }}
        />
      )}
    </>
  );
};
